import { State } from '../../stores/types/State';

export const selectProtectionPlansState = (state: State) =>
  state.pages.drp.protectionPlans;
